import React from 'react';

const pageSty = (_theme) => {
    let sty = {
        pageBox: {
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            margin: "0rem 2rem"
        },
        svg: {
            position: "relative",
            right: "1.5rem",
            top: "0.3rem",
            zIndex: "-20"
        },
        pageSizeBox: {
            display: "flex",
        },
        //条目数
        pageSize: {
            paddingLeft: "0.625rem",
            width: "3.75rem",
            height: "1.75rem",
            border: "0.08rem solid #cccccc",
            borderRadius: "0.125rem",
            marginLeft: "0.5rem",
            appearance: "none",
            MozAppearance: "none",
            WebkitAppearance: "none",
            background: "url('images/select.png') no-repeat right center",
            fontSize: "0.875rem",
            color: "#666666",
            outline: "none",
        },
        //分页数
        pageNumBox: {
            display: "flex",
        },

        showList: {
            listStyle: 'none',
            padding: '0',
            margin: '0.16rem 0',
            textAlign: 'center',
            border: "0.08rem solid",
            display: 'flex',
            flexDirection: 'column',
            zIndex: '6'
        },
        showList_none: {
            display: 'none'
        },
        pagebtnBox: {
            fontSize: "0.875rem",
            cursor: "pointer",
            width: "2rem",
            height: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#9a9a9a",
            border: "0.08rem solid #cccccc",
            borderRadius: "0.125rem",
        },
        pagebtnDisabled: {
            width: "2rem",
            height: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "0.08rem solid #e5e5e5",
            borderRadius: "0.125rem",
            cursor: "no-drop",
            color: "#9a9a9a",
        },
        pageNumCont: {
            display: "flex",
            marginRight: "0.375rem"
        },
        numBox: {
            cursor: "pointer",
            width: "2rem",
            height: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "0.08rem solid #cccccc",
            borderRadius: "0.125rem",
            color: "#666666",
            marginLeft: "0.375rem"
        },
        currentNum: {
            cursor: "pointer",
            width: "2rem",
            marginLeft: "0.375rem",
            height: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "0.08rem solid " + _theme.currentNumBg,
            borderRadius: "0.125rem",
            backgroundColor: _theme.currentNumBg,
            color: _theme.currentNum,
        },
        //文本
        textBox: {
            alignItems: "center",
            display: "flex",
            fontSize: "0.875rem",
            color: "#666666"
        },
        labelN: {
            padding: "0 0.5rem "
        },
        inputBox: {
            width: "2.375rem",
            textAlign: "center",
            margin: "0 0.375rem",
            outline: "none",
            padding: "0",
            height: '1.625rem',
            border: "0.08rem solid #cccccc",
            borderRadius: "0.125rem ",
        },
        jumpBox: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: _theme.jumpBg,
            color: "#fff",
            width: "2.5rem",
            margin: "0 0.5rem",
            fontSize: "1rem",
            cursor: "pointer",
            height: '1.625rem',
            border: "0.08rem solid #cccccc",
            borderRadius: "0.125rem",
        }
    };
    return sty
};

export {
    pageSty,
};
